import styles from './styleConstants.module.css';

type HProps = React.ComponentPropsWithoutRef<'h1'>;
type PProps = React.ComponentPropsWithoutRef<'p'>;

export const H1 = ({ className, ...props }: HProps) => (
  <h1 className={`${styles.h1}${className ? ` ${className}` : ''}`} {...props} />
);

export const H2 = ({ className, ...props }: HProps) => (
  <h2 className={`${styles.h2}${className ? ` ${className}` : ''}`} {...props} />
);

export const Subtitle = ({ className, ...props }: PProps) => (
  <p
    className={`${styles.subtitle}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const CaptionWithMB = ({ className, ...props }: PProps) => (
  <p
    className={`${styles.captionWithMB}${className ? ` ${className}` : ''}`}
    {...props}
  />
);
